module.exports = __webpack_public_path__ + "img/Association_VPA_2.bd9b3fd3.jpg";